import { useQuery } from '@tanstack/react-query';
import { request } from '../axios';

export interface ValidateDuplicateAddressParams {
  address: string;
}

export function checkAddressDuplicate(params: ValidateDuplicateAddressParams) {
  return request<boolean>({
    url: '/api/addresses/validate-duplicate',
    method: 'GET',
    params,
  });
}

export function useCheckAddressDuplicate(address: string, enabled = true) {
  const normalizedAddress = address.trim();

  return useQuery({
    queryKey: ['validate-duplicate-address', normalizedAddress],
    queryFn: () => checkAddressDuplicate({ address: normalizedAddress }),
    enabled: enabled && !!normalizedAddress,
  });
}
